import { render, staticRenderFns } from "./BusinessUnitSelectBox.vue?vue&type=template&id=12f25149&scoped=true&"
import script from "./BusinessUnitSelectBox.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f25149",
  null
  
)

export default component.exports